import React, { useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { toastr } from 'react-redux-toastr';
import { connect } from 'react-redux';
import Toggle from 'react-toggle';
import _ from 'lodash';

import { createDevicesCustomer, uploadVehicles } from '../../../action/DeviceActions';
import ModalUploadFile from '../../../component/common/modals/ModalUploadFile'
import { vinValidation, imeiValidation } from '../../helpers/helperVehicle'

import '../../dump/menuComponents/menuComponents.sass'
import '../../dump/menuComponents/manageVehicles.sass'
import CustomButton from '../../CustomButton';

const AddAssetContainer = (props) => {
	const { company, user, companiesList, toggleLoader } = props;
	const userRole = user.roles[0];

	const [addVehicleModal, setAddVehicleModal] = useState(false);
	const [vehiclesObj, setVehiclesObj] = useState([{
		sn: '',
		vin: '',
		tag_plate: '',
		name: '',
		enable_ch3: false,
	}]);
	const [showUploadDevices, setShowUploadDevices] = useState(false);
	const [fileUploadDevices, setFileUploadDevices] = useState(null);
	const [selectCompany, setSelectCompany] = useState("");

	const openAddVehiclesModal = () => {
		setAddVehicleModal(true)
	}

	const changeField = (e, i, type) => {
		const updatedVehicles = [...vehiclesObj];
		setVehiclesObj(_.set(updatedVehicles, `${i}.${type}`, e.target.value))
	}

	const removeVehicle = (index) => {
		const updatedVehicles = [...vehiclesObj];
		updatedVehicles.splice(index, 1)
		setVehiclesObj(updatedVehicles)
	}

	const validateVehiclesObj = () => {
		const { sn, vin } = vehiclesObj[0]
		if (!vehiclesObj.length) {
			toastr.error('Please enter an IMEI, VIN, and/or Name')
			return false;
		}

		if (!sn) {
			toastr.error('Please enter an IMEI')
			return false;
		}

		if (!(/^(XC4RECO|DV401)/.test(sn) || /^\D*(?:\d\D*){15}$/.test(sn))) {
			toastr.error('The IMEI must exactly 15 numbers. Please try again.')
			return false;
		}

		if (!imeiValidation(sn)) {
			toastr.error('Incorrect IMEI entered, please check and try again.')
			return false;
		}

		if (vin && !vinValidation(vin)) {
			toastr.error(`Incorrect VIN entered, please check and try again.`)
			return false;
		}

		// if (!vehicle.sn) {
		// 	toastr.error('Please enter an IMEI')
		// 	return false;
		// }
		//
		// for (let vehicle of vehiclesObj) {
		// 	if (!(/^(XC4RECO|DV401)/.test(vehicle.sn) || /^\D*(?:\d\D*){15}$/.test(vehicle.sn))) {
		// 		toastr.error('The IMEI must exactly 15 numbers. Please try again.')
		// 		return false;
		// 	}
		//
		// 	if (!vinValidation(vehicle.vin)) {
		// 		toastr.error(`Incorrect VIN, please check and try again.`)
		// 		return false;
		// 	}
		// }

		return true;
	}

	const createVehicle = () => {
		const { user, changedDevicesList } = props;

		if (validateVehiclesObj()) {
			const data = {
				snlist: JSON.stringify(vehiclesObj),
				partner_name: user.company_name,
				company_name: selectCompany,
				user_role: userRole,
			}
			createDevicesCustomer(data)
				.then(() => {
					toastr.success('Successfully added vehicles')
					setAddVehicleModal(false);
					setVehiclesObj([{
						sn: '',
						vin: '',
						tag_plate: '',
						name: '',
						enable_ch3: false,
					}]);
					changedDevicesList();
				})
				.catch((err) => {
					console.error('AddAssetContainer createVehicle error: ', err.response)
					toastr.error(err.response.data.response.error)
				})
		}
	}

	const createRandomVehicle = () => {
		toggleLoader(true);

		const params = {
			number: vehiclesObj.length,
			partner_name: user.company_name,
			company_name: selectCompany,
			user_role: userRole,
		};

		createDevicesCustomer(params)
			.then(res => {
				toggleLoader(false);

				toastr.success('Successfully added vehicles')
				setAddVehicleModal(false)
				props.changedDevicesList()
			})
			.catch(err => {
				toggleLoader(false);
				toastr.error('An unexpected error occurred. Please try again later.')
			});
	}

	const onFileChange = (e) => {
		const { value } = e.target;
		const file = e.target.files[0];
		setFileUploadDevices(file);

		let i
		if (value.lastIndexOf('\\')) {
			i = value.lastIndexOf('\\') + 1;
		} else {
			i = value.lastIndexOf('/') + 1;
		}
		const filename = value.slice(i);
		const uploaded = document.getElementById('upload-form-label');
		uploaded.innerHTML = filename;
	}

	const onUploadVehicles = (e) => {
		e.preventDefault()

		if (!fileUploadDevices) {
			toastr.warning('You should select CSV/Excel file')
			return
		}

		const params = {
			file: fileUploadDevices,
			company_id: company.company_id,
		}
		toggleLoader(true);
		uploadVehicles(params)
			.then((res, err) => {
				// console.log('onUploadVehicles res: ', res, err)
				toggleLoader(false);
				toastr.success('', 'File Successfully Uploaded')
			})
			.catch((error) => {
				console.log('onUploadVehicles error: ', error.response, error)
				toggleLoader(false);
				const { status, data } = error.response
				if (status >= 400 && status < 500) {
					toastr.error(data.response.error);
				} else {
					toastr.error('Unable to upload vehicles. Please try again later.');
				}
			})
	}

	// FWSD-4421
	const hasGeneralRandomAccess = () => {
		return !['partner'].includes(userRole)
	}

	const handleToggleChange = (e) => {
		const [data] = vehiclesObj;
		setVehiclesObj([{ ...data, enable_ch3: e.target.checked }]);
	}

	return (
		<div className="add-asset-block">
			<CustomButton
				variant="secondary-outline"
				onClick={openAddVehiclesModal}
				// disabled={userRole !== 'partner'}
			>
				Add a New Vehicle
			</CustomButton>

			<Modal
				show={addVehicleModal}
				onHide={() => {
					setAddVehicleModal(false);
					setVehiclesObj([{
						sn: '',
						vin: '',
						tag_plate: '',
						name: '',
						enable_ch3: false,
					}]);
				}}
				className='manage-vehicles-modal'
			>
				<Modal.Header closeButton>
					<Modal.Title id="contained-modal-title-lg">
						Add Vehicles
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<div>
						<div className="form-group">
							<select
								className="rosco-select block"
								onChange={(e) => setSelectCompany(e.target.value)}
							>
								{companiesList.map((elm) => (<option value={elm.company_name} key={elm.id}>{elm.company_name}</option>))}
							</select>
						</div>
						<h5 style={{ paddingTop: '10px', fontSize: '20px', color: "#ED1E79" }}>Enter the IMEI, VIN, License plate and/or Name</h5>
						<div className='add-vehicles-container'>
							{vehiclesObj.map((vehicle, index) => (
								<div className="new-vehicle-wrapper" key={index}>
									{/* <div>{index + 1}</div> */}
									<input type="text" className="vehicle-search" value={vehicle.sn} placeholder="Camera IMEI" onChange={(e) => changeField(e, index, 'sn')} />
									<input type="text" className="vehicle-search" value={vehicle.vin} placeholder="VIN (optional)" onChange={(e) => changeField(e, index, 'vin')} />
									<input type="text" className="vehicle-search" value={vehicle.tag_plate} placeholder="License plate (optional)" onChange={(e) => changeField(e, index, 'tag_plate')} />
									<input type="text" className="vehicle-search" value={vehicle.name} placeholder="Camera Name (optional)" onChange={(e) => changeField(e, index, 'name')} />
									<div className="active-channel-3-container">
										<span className="toggle-left-title">Channel 3</span>
										<Toggle
											name="active_channel_3"
											checked={vehicle.enable_ch3}
											onChange={handleToggleChange}
										/>
									</div>
									{index > 0
										? <CustomButton variant="primary-outline" size="x-small" title='Remove Vehicle' onClick={() => removeVehicle(index)}>-</CustomButton>
										: <div className="empty-div" />
									}
								</div>
							))}
						</div>
					</div>
				</Modal.Body>
				<Modal.Footer>
					{hasGeneralRandomAccess() && (
						<CustomButton variant="primary-outline" onClick={createRandomVehicle}>
							Generate Random
						</CustomButton>
					)}
					<CustomButton
						variant="primary-outline"
						title="Upload a Excel/CSV file with device serial and vin numbers"
						onClick={() => setShowUploadDevices(true)}
					>
						Upload Vehicles From File
					</CustomButton>
					<CustomButton variant="secondary" onClick={createVehicle}>Create</CustomButton>
				</Modal.Footer>
			</Modal>

			{showUploadDevices
				&& (
					<ModalUploadFile
						title="Upload CSV"
						description="Upload a CSV file with camera serial number (IMEI for DV6) and VINs"
						exampleFileTitle="Example CSV File"
						exampleFileLink="/files/rosco_vehicles_example.csv"
						btnUploadTitle="Add New Vehicles"
						acceptFileExtensions=".csv"

						onFileChange={onFileChange}
						onUploadFile={onUploadVehicles}
						onHide={() => setShowUploadDevices(false)}
					/>
				)}
		</div>
	)
}

export default connect(
	state => ({
		user: state.user.user,
		company: state.company.company
	}),
	dispatch => ({
		toggleLoader: (show) => {
			dispatch({ type: 'TOGGLE_LOADER', payload: show });
		}
	})
)(AddAssetContainer);
